import React from 'react';

import ListBase from './ListBase';
import { TList } from './types';

const Basic: React.FC<TList> = (props) => <ListBase {...props} as="ul" />;

export default Basic;
